import React from "react";
import { AlertTriangle, CheckCircle2, Mail } from "lucide-react";

const sevenYearsAgo = () => { const d = new Date(); d.setFullYear(d.getFullYear() - 7); return d.toISOString().slice(0, 7); };
const ym = (s: string) => (s ? `${s.slice(5, 7)}/${s.slice(0, 4)}` : "");

const STOP = ["info", "admin", "contact", "mail", "office", "volunteer", "delivered", "test", "home", "work", "family", "hello", "noreply", "church", "school", "parish"];

function emailHint(p: any): string {
  let local = (p.email || "").split("@")[0].toLowerCase().replace(/[^a-z]/g, "");
  const first = (p.first_name || "").toLowerCase().replace(/[^a-z]/g, "");
  if (!first || !(local.startsWith(first) || local.startsWith(first[0]))) return "";
  local = local.startsWith(first) ? local.slice(first.length) : local.slice(1);
  const known = [p.middle_name, p.last_name, p.birth_last_name, ...(p.marriages || []).map((m: any) => m.prev_last)]
    .flatMap((x: string) => (x || "").toLowerCase().split(/[^a-z]+/)).filter((x: string) => x.length >= 2).sort((a: string, b: string) => b.length - a.length);
  if (known.some((k: string) => local === k || local.slice(1) === k)) return "";
  for (const k of known) local = local.split(k).join(" ");
  const mid = (p.middle_name || "").toLowerCase()[0];
  const left = local.split(" ").map((x: string) => (mid && x.length > 4 && x[0] === mid ? x.slice(1) : x)).filter((x: string) => x.length >= 4 && !STOP.some((s) => x.includes(s)));
  return left.sort((a: string, b: string) => b.length - a.length)[0] || "";
}

export function NameFlags({ p }: { p: any }) {
  const rows = p.name_changed === "yes" ? p.marriages || [] : [];
  const cut = sevenYearsAgo();
  const recent = rows.filter((r: any) => r.date && r.date >= cut);
  const hint = emailHint(p);
  const legacy = !p.name_changed;
  return (
    <div className="space-y-2" data-testid="case-name-flags">
      {!legacy && (recent.length ? (
        <p className="flex items-start gap-2 rounded-lg bg-[#FEF3C7] px-3 py-2 text-xs font-semibold text-[#92400E]" data-testid="case-name-recent">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" /> Name change within 7 years: AKA search needed ({recent.map((r: any) => `${r.prev_last} until ${ym(r.date)}`).join("; ")})
        </p>
      ) : rows.length ? (
        <p className="flex items-start gap-2 rounded-lg bg-[#F0FDF4] px-3 py-2 text-xs font-semibold text-[#166534]" data-testid="case-name-old">
          <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0" /> Name change older than 7 years: no out-of-state AKA needed
        </p>
      ) : null)}
      {hint && (
        <p className="flex items-start gap-2 rounded-lg bg-[#EEF2FF] px-3 py-2 text-xs font-semibold text-[#3730A3]" data-testid="case-email-name-hint">
          <Mail className="mt-0.5 h-4 w-4 shrink-0" /> Possible other last name: the email contains "{hint}", which doesn't match the names entered
        </p>
      )}
    </div>
  );
}
